// mock地址
const mockService = "http://mock.o-wu.com/mock/5d9fe56957a4f01beaab5ed1/class";
const testFinalCoursewareApiService = "https://final-courseware-api.caihonggou.com";
const testFinalAdminApiService = "https://final-admin-api.caihonggou.com";
const prodFinalCoursewareApiService = "https://final-courseware-api.aikaola.com";
const prodFinalAdminApiService = "https://final-admin-api.aikaola.com";
export const devPublicUrl = {
  mockService,
  finalCoursewareApiService: testFinalCoursewareApiService,
  finalAdminApiService: testFinalAdminApiService,
};

// 测试版公网IP-URL
export const testPublicUrl = {
  mockService,
  finalCoursewareApiService: testFinalCoursewareApiService,
  finalAdminApiService: testFinalAdminApiService,
};

// 发布版公网地址-URL
export const prodPublicUrl = {
  mockService,
  finalCoursewareApiService: prodFinalCoursewareApiService,
  finalAdminApiService: prodFinalAdminApiService,
};
